// Module
var code = `<div class="col-sm-2"></div> <div class="col-sm-10"> <div ng-if="formErrorController.errors.length > 0" class="form-error"> <h3>{{ 'Form.Error.Title' | translate }}</h3> <ol> <li ng-repeat="error in formErrorController.errors"> {{ error.message | translate }} </li> </ol> </div> </div> `;
// Exports
module.exports = code;